import React from 'react'
import Layout from '../components/Layout/Layout'

const About = () => {
    return (
        <Layout>About</Layout>
    )
}

export default About